import type {
  CreateIntegrationSagaPayloadType,
  CreateTechnologySagaPayloadType,
  DeleteTechnologySagaPayloadType,
  GetIntegrationByIdSagaPayloadType,
  UpdateIntegrationSagaPayloadType,
  UpdateTechnologySagaPayloadType,
} from "../../../slices/technology-settings/technologies/Types";

export const technologySettingsTechnologiesSagaActionTypes = {
  callGetTechnologiesSaga: "callGetTechnologiesSaga",
  callCreateTechnologySaga: "callCreateTechnologySaga",
  callUpdateTechnologySaga: "callUpdateTechnologySaga",
  callDeleteTechnologySaga: "callDeleteTechnologySaga",
  callGetIntegrationByIdSaga: "callGetIntegrationByIdSaga",
  callCreateIntegrationSaga: "callCreateIntegrationSaga",
  callUpdateIntegrationSaga: "callUpdateIntegrationSaga",
};

export const getTechnologiesSagaAction: () => { type: string } = () => ({
  type: technologySettingsTechnologiesSagaActionTypes.callGetTechnologiesSaga,
});

export const createTechnologySagaAction: (
  payload: CreateTechnologySagaPayloadType
) => {
  type: string;
  payload: CreateTechnologySagaPayloadType;
} = (payload) => ({
  type: technologySettingsTechnologiesSagaActionTypes.callCreateTechnologySaga,
  payload,
});

export const updateTechnologySagaAction: (
  payload: UpdateTechnologySagaPayloadType
) => {
  type: string;
  payload: UpdateTechnologySagaPayloadType;
} = (payload) => ({
  type: technologySettingsTechnologiesSagaActionTypes.callUpdateTechnologySaga,
  payload,
});

export const deleteTechnologySagaAction: (
  payload: DeleteTechnologySagaPayloadType
) => {
  type: string;
  payload: DeleteTechnologySagaPayloadType;
} = (payload) => ({
  type: technologySettingsTechnologiesSagaActionTypes.callDeleteTechnologySaga,
  payload,
});

export const getIntegrationByIdSagaAction: (
  payload: GetIntegrationByIdSagaPayloadType
) => {
  type: string;
  payload: GetIntegrationByIdSagaPayloadType;
} = (payload) => ({
  type: technologySettingsTechnologiesSagaActionTypes.callGetIntegrationByIdSaga,
  payload,
});

export const createIntegrationSagaAction: (
  payload: CreateIntegrationSagaPayloadType
) => {
  type: string;
  payload: CreateIntegrationSagaPayloadType;
} = (payload) => ({
  type: technologySettingsTechnologiesSagaActionTypes.callCreateIntegrationSaga,
  payload,
});

export const updateIntegrationSagaAction: (
  payload: UpdateIntegrationSagaPayloadType
) => {
  type: string;
  payload: UpdateIntegrationSagaPayloadType;
} = (payload) => ({
  type: technologySettingsTechnologiesSagaActionTypes.callUpdateIntegrationSaga,
  payload,
});
